const meta = {
  chronoctl: 'Chronoctl',
  'api-info': 'API',
  infrastructure: 'Infrastructure as code',
  'prometheus-api': 'Prometheus API',
  gitops: 'Gitops workflow',
};

export default meta;
